import Page from '@inspire/ui/chakra/layout/Page';

import { useFaqItems, useMyProfile } from 'lib/hooks';
import FAQItem from 'components/faq/FAQItem';
import Layout from 'components/layout/Layout';

const FAQPage = () => {
  const { faqItems, areFaqItemsLoading } = useFaqItems();
  useMyProfile(); // to trigger lastDayOfActivity update

  return (
    <Page
      isLoading={areFaqItemsLoading}
      title="FAQ - Questions fréquentes"
      headingIsTitle
    >
      {faqItems?.map((i) => (
        <FAQItem key={i._id} item={i} style={{ marginBottom: '1rem' }} />
      ))}
    </Page>
  );
};

FAQPage.getWrappers = (page) => (
  <Layout variant="adaptative" rowVariant="gray">
    {page}
  </Layout>
);

export default FAQPage;
